// "Setup incomplete" (owner 2026-10-30: his target existed, but no route used
// it, and nothing said so): a piece that isn't linked to the next one gets an
// amber pill in its list and on its page, and a short notice holding the
// button that finishes it. Amber is a missing step; red stays for real
// failures. Each answers null when the piece is linked, else
// { text, action }.
export const SETUP_PILL = 'Setup incomplete'

// A target no route uses: only a test reaches it.
export const targetSetup = target => (target && (target.usedBy || 0) === 0
  ? { text: 'Not on any route: only tests reach it.', action: 'Add to a route' }
  : null)

// A route with no target switched on: it matches, and sends nowhere.
export const enabledActions = route => ((route && route.actions) || []).filter(a => a.targetID && a.enabled !== false)
export const routeSetup = route => (route && enabledActions(route).length === 0
  ? { text: 'Sends nowhere yet.', action: 'Add a target' }
  : null)

// A connected workspace no target posts through. A disconnected one is done
// with, not unfinished.
export const connectionSetup = connection => (connection && connection.status !== 'disconnected' && (connection.targets || []).length === 0
  ? { text: 'No targets use this workspace yet.', action: 'New Slack target' }
  : null)

// One amber pill at a time (owner 2026-11-02): a workspace whose status asks
// for something (Needs approval, Reconnect) shows that status alone, and its
// "Setup incomplete" pill waits until it is Connected. The setup notice on its
// page still says what is missing.
export const connectionSetupPill = (connection, stateKey) => (stateKey === 'connected' ? connectionSetup(connection) : null)
